//-----------------------------------
// gw.js
// => theme/templates/index.liquid
//-----------------------------------

import $ from 'jquery';
let $collectionTypesNav = $('.CollectionTypesNav-list');

// Index Module
// ---------------------------------------
export let openNav = {

    init() {
      
    $collectionTypesNav.click(function(){
        $(this).toggleClass('is-open');
    });
    
}
  
  }
  
  